module.exports = __webpack_public_path__ + "img/電気回路_4_2_5.4208e5b8.png";